// The catch-up page's opportunities pile — which proposals are in the stack and in which order.
//
// The pile is drawn back-to-front: every card overlaps the one before it and only the LAST one is
// open (workspace, title, CTA); the ones behind show just their head. Pressing a head brings that card
// forward. Mirrors native's `OpportunitiesDeck`, including its three-card cap.

/** The pile draws the open card plus at most two peeking behind it. */
export const PILE_SIZE = 3;

/**
 * Order a pile back-to-front for a given front card.
 *
 * The front card is last (it renders on top); the ones behind keep the list's own order, so the pile
 * doesn't reshuffle every time a card is raised. An unknown or missing `frontId` falls back to the
 * first opportunity, so a stale selection can never empty the stack.
 */
export function pileOrder<T extends { id: string }>(opportunities: T[], frontId?: string | null): T[] {
  const front = opportunities.find((o) => o.id === frontId) ?? opportunities[0];
  if (!front) return [];
  const behind = opportunities.filter((o) => o.id !== front.id).slice(0, PILE_SIZE - 1);
  return [...behind.reverse(), front];
}

/**
 * Whether the section can expand into the full list — true once there are MORE proposals than the
 * collapsed pile can draw. Mirrors native's `showsViewMore(count) = count > maxDeckCards`: the
 * "View More (N)" toggle appears only when the list holds something the pile can't. N itself is the
 * TOTAL count the expanded list reveals, not the hidden remainder (also matching native).
 */
export function canExpandOpportunities(total: number): boolean {
  return total > PILE_SIZE;
}
